import * as R from "ramda"
import moment from 'moment'
import { getStoreKeyByName } from "../Steps";
import { dateFormat } from "../lib/settings";

const nameStoreFormValue = getStoreKeyByName('extras')

const extrasFormData = {
  cookiesCategories: [
    { label: 'Strictly necessary cookies', value: 'Strictly necessary cookies', disabled: true, custom: false },
    { label: 'Performance cookies', value: 'Performance cookies', disabled: false, custom: false },
    { label: 'Targeting cookies', value: 'Targeting cookies', disabled: false, custom: false },
    { label: 'Functionality cookies', value: 'Functionality cookies', disabled: false, custom: false },
    { label: 'Unclassified cookies', value: 'Unclassified cookies', disabled: false, custom: false },
  ],

  privacyOfficers : [
    { label: 'Privacy Officer', value: 'Privacy Officer', disabled: false, custom: false },
    { label: 'Data Protection Officer', value: 'Data Protection Officer', disabled: false, custom: false },
    { label: 'No person, just use company contacts', value: 'No person, just use company contacts', disabled: false, custom: false },
  ],
  userBanners: [],
}


const defaultValue = {
  cookiesCategories: ['Strictly necessary cookies'],
  privacyOfficer: 'Privacy Officer',
  cookieId: '',
  officerName: '',
  officerEmail: '',
  officerPhone: '',
  effectiveDate: moment().format(dateFormat),
}

export const extrasFormState = set =>  ({
  extrasFormData: extrasFormData,
  resetExtrasFormData: () => set({ extrasFormData: extrasFormData }),
  changeExtrasFormDataByKey: (key, value) => (set(state => {
    return { extrasFormData:  { ...state.extrasFormData, [key]: value } }
  })),
  addExtrasFormDataByKey: (key, item) => (set(state => {
    const newValue = [...state.extrasFormData[key], item ];
    return { extrasFormData:  { ...state.extrasFormData, [key]: newValue } }
  })),
  removeExtrasFormDataByKey: (key,item) => set(state => {
    const compareFunc = option => option.value !== item.value
    const newValue = R.filter(compareFunc, state.extrasFormData[key])

    return { extrasFormData:  { ...state.extrasFormData, [key]: newValue } }
  }),

  [nameStoreFormValue]:  defaultValue,
  resetExtrasFormValue: () => set({ [nameStoreFormValue]: defaultValue  }),
  setExtrasFormValue: value => set({ [nameStoreFormValue]: value}),
  changeExtrasFormValue: (name, value) =>
    set(state => ({ [nameStoreFormValue]: {...state[nameStoreFormValue], [name]: value } })),
})